
 var TrandingSlider = new Swiper('.u-featured-products-box', {
    loop: true,
    effect: "coverflow",
    grabCursor: true,
    preloadImages: true,
    centeredSlides: true,
    init: true,
    loopAdditionalSlides: 1,
    slidesPerView: "auto",
    coverflowEffect: {
       rotate: 4,
       stretch: 0,
       depth: 200,
       modifier: 0.5,
       slideShadows: true,
    },
    navigation: {
       nextEl: ".swiper-button-next",
       prevEl: ".swiper-button-prev",
    },
 });


  
